/* Natural Glow — Home estilo Lummia. Scripts de las secciones ng-home-*. */

/* ===== ng-home-productos ===== */
(() => {
  const iniciar = (raiz = document) => {
    raiz.querySelectorAll('[data-ng-escaparate]').forEach((sec) => {
      if (sec.dataset.ngListo) return;
      sec.dataset.ngListo = 'true';
      const pista = sec.querySelector('[data-ng-pista]');
      const items = [...pista.children];
      if (!items.length) return;

      const centrar = (i, suave) => {
        const item = items[Math.max(0, Math.min(items.length - 1, i))];
        const izq = item.offsetLeft - (pista.clientWidth - item.offsetWidth) / 2;
        pista.scrollTo({ left: izq, behavior: suave ? 'smooth' : 'instant' });
      };

      const actual = () => {
        const centro = pista.scrollLeft + pista.clientWidth / 2;
        let mejor = 0;
        let dist = Infinity;
        items.forEach((it, i) => {
          const d = Math.abs(it.offsetLeft + it.offsetWidth / 2 - centro);
          if (d < dist) { dist = d; mejor = i; }
        });
        return mejor;
      };

      // Arranca con el producto elegido al centro (así se ven tarjetas a ambos lados)
      centrar(parseInt(sec.dataset.inicio, 10) || 0, false);

      sec.querySelectorAll('[data-ng-flecha]').forEach((b) => {
        b.addEventListener('click', () => centrar(actual() + Number(b.dataset.ngFlecha), true));
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => iniciar());
  else iniciar();
  document.addEventListener('shopify:section:load', (e) => iniciar(e.target));
  document.addEventListener('shopify:block:select', (e) => {
    const item = e.target.closest('.ng-escaparate__item');
    if (item) item.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  });
})();

/* ===== ng-home-video =====
   iPhone solo reproduce solo si el <video> trae muted + playsinline + autoplay
   ANTES de cargar, y con el modo de bajo consumo bloquea incluso el play() por
   JavaScript: por eso hay un plan B al primer toque o desplazamiento. */
(() => {
  const pendientes = new Set();

  const intentar = (video) => {
    if (video.offsetParent === null) return; // el oculto (PC o celular) no se toca
    const p = video.play();
    if (p && p.catch) p.catch(() => pendientes.add(video));
  };

  const reintentar = () => {
    pendientes.forEach((v) => {
      const p = v.play();
      if (p && p.then) p.then(() => pendientes.delete(v)).catch(() => {});
    });
  };
  ['touchstart', 'pointerdown', 'scroll', 'click'].forEach((ev) =>
    document.addEventListener(ev, reintentar, { passive: true })
  );

  const iniciar = () => {
    document.querySelectorAll('[data-ng-videobanner]').forEach((video) => {
      if (video.dataset.ngListo) return;
      video.dataset.ngListo = 'true';

      // Atributos que iOS exige para reproducir sin que la persona toque nada
      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.removeAttribute('loading');

      if (video.offsetParent !== null) video.setAttribute('autoplay', '');

      // Fuente y portada solo cuando ya está cerca y solo en el visible (antes
      // los dos videos del inicio bajaban ~6 MB al abrir la página)
      const cargar = () => {
        if (video.offsetParent === null || !window.ngVideo) return;
        window.ngVideo.cargar(video, intentar);
      };
      const cerca = new IntersectionObserver(
        ([en]) => {
          if (!en.isIntersecting) return;
          cerca.disconnect();
          cargar();
        },
        { rootMargin: '1200px 0px' }
      );
      cerca.observe(video);

      const obs = new IntersectionObserver(
        ([en]) => {
          if (en.isIntersecting && video.offsetParent !== null) {
            cargar();
            intentar(video);
          } else if (!video.paused) {
            video.pause();
          }
        },
        { threshold: 0.2 }
      );
      obs.observe(video);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
  document.addEventListener('shopify:section:load', iniciar);
})();

/* ===== ng-home-video: barra "cargando" sincronizada con el video ===== */
(() => {
  const iniciar = (raiz = document) => {
    raiz.querySelectorAll('[data-ng-videobanner-sec]').forEach((sec) => {
      const carga = sec.querySelector('[data-ng-carga]');
      if (!carga || carga.dataset.ngListo) return;
      carga.dataset.ngListo = 'true';
      const texto = carga.dataset.texto || '';
      const relleno = carga.querySelector('[data-ng-carga-relleno]');
      const letras = carga.querySelector('[data-ng-carga-texto]');
      const videos = [...sec.querySelectorAll('video')];
      if (!videos.length) return; // sin video: la animación CSS se encarga

      const pintar = () => {
        const v = videos.find((x) => x.offsetParent !== null) || videos[0];
        if (v.duration) {
          const p = v.currentTime / v.duration;
          relleno.style.width = Math.min(100, p * 118) + '%'; // llega al 100% un poco antes del final
          letras.textContent = texto.slice(0, Math.ceil(texto.length * Math.min(1, p / 0.45)));
        }
        // Mientras el video está en pausa (fuera de pantalla) se revisa sin prisa
        if (v.paused) setTimeout(() => requestAnimationFrame(pintar), 500);
        else requestAnimationFrame(pintar);
      };
      letras.textContent = '';
      requestAnimationFrame(pintar);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => iniciar());
  else iniciar();
  document.addEventListener('shopify:section:load', (e) => iniciar(e.target));
})();
